var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1C10.4477 1 10 1.44772 10 2C10 2.55228 10.4477 3 11 3H11.5523L9.95955 4.59273C9.56903 4.98325 9.56903 5.61642 9.95955 6.00694C10.3501 6.39746 10.9832 6.39746 11.3738 6.00694L13 4.3807V5C13 5.55229 13.4477 6 14 6C14.5523 6 15 5.55229 15 5V2C15 1.44772 14.5523 1 14 1H13.9665H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4073 9.95956C11.0168 9.56903 10.3836 9.56903 9.99309 9.95956C9.60256 10.3501 9.60256 10.9832 9.99309 11.3738L11.6193 13H11C10.4477 13 10 13.4477 10 14C10 14.5523 10.4477 15 11 15H14C14.5523 15 15 14.5523 15 14V13.974C15 13.969 15 13.964 15 13.959V11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V11.5523L11.4073 9.95956Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03686 11.3773C6.42935 10.9888 6.43255 10.3556 6.044 9.96314C5.65545 9.57065 5.0223 9.56745 4.62981 9.956L3 11.5694V11C3 10.4477 2.55228 10 2 10C1.44772 10 1 10.4477 1 11L1 13.9665C1 13.9665 1 13.9666 1 13.9666L1 14C1 14.5523 1.44772 15 2 15H5C5.55229 15 6 14.5523 6 14C6 13.4477 5.55229 13 5 13H4.39772L6.03686 11.3773Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07491 1.61955C1.02663 1.73683 1 1.8653 1 2V5C1 5.55229 1.44772 6 2 6C2.55228 6 3 5.55229 3 5V4.39708L4.62981 6.0105C5.0223 6.39905 5.65545 6.39585 6.044 6.00336C6.43255 5.61087 6.42935 4.97771 6.03686 4.58916L4.43156 3H5C5.55229 3 6 2.55228 6 2C6 1.44772 5.55229 1 5 1H2.00003H2C1.86347 1 1.73333 1.02736 1.61476 1.0769C1.49697 1.126 1.38669 1.19861 1.29111 1.29468C1.29052 1.29528 1.28992 1.29588 1.28933 1.29647C1.28735 1.29847 1.28538 1.30048 1.28342 1.3025"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.8d0c2c88.svg";
export { ForwardRef as ReactComponent };